import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import { abbreviateNumber, fullNumber } from "../../../utils/numberFormatting.utils";
import { allAppsWidth } from "../Common/ReportsTableSummary";
import { getCloudConversionsTableData } from "./CloudConversions.utils";
export const Cell = _styled("div", {
  target: "eoia0cc0",
  label: "Cell"
})(process.env.NODE_ENV === "production" ? {
  name: "o6l5fu",
  styles: "padding:5px 0;"
} : {
  name: "o6l5fu",
  styles: "padding:5px 0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const totalColumns = 3;
export const CloudConversionsHeader = {
  cells: [{
    key: 'string',
    content: 'App',
    isSortable: true,
    style: {
      width: "".concat(allAppsWidth, "%")
    }
  }, {
    key: 'evaluations',
    content: 'Evaluations',
    isSortable: true,
    style: {
      width: "".concat((100 - allAppsWidth) / totalColumns, "%")
    }
  }, {
    key: 'conversions',
    content: 'Conversions',
    isSortable: true,
    style: {
      width: "".concat((100 - allAppsWidth) / totalColumns, "%")
    }
  }, {
    key: 'conversionRate',
    content: 'Conversion rate',
    isSortable: true,
    style: {
      width: "".concat((100 - allAppsWidth) / totalColumns, "%")
    }
  }]
};
export const getCloudConversionsBody = cloudConversionsAPIResponse => {
  if (!cloudConversionsAPIResponse) {
    return [];
  }

  const cloudConversionsTableData = getCloudConversionsTableData(cloudConversionsAPIResponse);
  return cloudConversionsTableData.map(item => ({
    key: item.appKey,
    cells: [{
      key: item.appName,
      content: /*#__PURE__*/React.createElement(Cell, null, item.appName)
    }, {
      key: item.evaluations,
      content: /*#__PURE__*/React.createElement(Tooltip, {
        content: fullNumber(item.evaluations)
      }, /*#__PURE__*/React.createElement("span", null, abbreviateNumber(item.evaluations)))
    }, {
      key: item.conversions,
      content: /*#__PURE__*/React.createElement(Tooltip, {
        content: fullNumber(item.conversions)
      }, /*#__PURE__*/React.createElement("span", null, abbreviateNumber(item.conversions)))
    }, {
      key: item.conversationRate,
      content: "".concat(item.conversationRate, "%")
    }]
  }));
};